import { Component, Input, OnChanges } from '@angular/core';
import { WidgetDisplayConfig, WidgetType, WidgetWithData } from '@models/widget/widget.model';
import { WIDGET_NUMBER_DEFAULT_COLOR } from '@models/widget/widget.constants';
import { buildPreviewWidget, WidgetPreviewEntryMeta } from '../widget-preview-data';

@Component({
  standalone: false,
  selector: 'app-widget-preview',
  templateUrl: './widget-preview.component.html',
  styleUrls: ['./widget-preview.component.scss'],
})
export class WidgetPreviewComponent implements OnChanges {
  @Input() type: WidgetType = 'NUMBER';
  @Input() title = 'Título del widget';
  @Input() config: WidgetDisplayConfig = {};
  @Input() entries: WidgetPreviewEntryMeta[] = [];

  previewWidget: WidgetWithData = buildPreviewWidget(this.type, this.title, this.config, this.entries);

  ngOnChanges(): void {
    this.previewWidget = buildPreviewWidget(this.type, this.title, this.config, this.entries);
  }

  get previewColor(): string {
    return this.entries?.[0]?.color || (this.type === 'NUMBER' ? WIDGET_NUMBER_DEFAULT_COLOR : '#3B82F6');
  }
}
